export const VisibilityStates = Object.freeze({
  Visible: 'Visible',
  Hidden: 'Hidden',
  AnimatingOut: 'AnimatingOut',
});

export type VisibilityState =
  (typeof VisibilityStates)[keyof typeof VisibilityStates];

export const PlayStates = Object.freeze({
  Playing: 'Playing',
  Paused: 'Paused',
  NoPlayer: 'NoPlayer',
});

export type PlayState = (typeof PlayStates)[keyof typeof PlayStates];
